import { Component, EventEmitter, Input, Output, inject } from "@angular/core"
import { MatDialog } from "@angular/material/dialog"
import { MatIcon } from "@angular/material/icon"
import { MatTooltip } from "@angular/material/tooltip"
import { LandlordData, ModifyLandlordData } from "src/app/models"
import { LandlordDataDialogComponent } from "./landlord-data-dialog.component"

@Component({
    selector: "valben-landlord-data-modal",
    standalone: true,
    template: `
        <button
            type="button"
            class="valben-row-action"
            [attr.aria-label]="tooltip"
            [matTooltip]="tooltip"
            (click)="open()">
            <mat-icon>{{ icon }}</mat-icon>
        </button>`,
    imports: [MatIcon, MatTooltip],
})
export class LandlordDataModalComponent {
    @Input() data: LandlordData | null = null
    @Output() saveChanges = new EventEmitter<ModifyLandlordData>()
    @Input() icon: string = "real_estate_agent"
    @Input() tooltip: string = "Detalji"

    private readonly _dialog = inject(MatDialog)

    open(): void {
        const ref = this._dialog.open(LandlordDataDialogComponent, {
            data: this.data,
            width: "min(72rem, 92vw)",
            maxWidth: "92vw",
        })

        // Saving keeps the dialog open (it flips back to preview), so the result has to come out
        // through the output rather than afterClosed().
        ref.componentInstance.saveChanges.subscribe(value => this.saveChanges.emit(value))
    }
}
